module.exports = __webpack_public_path__ + "assets/media/salesforce-pardot-logo.886db4e8.svg";